import { LeadsSearchQuery } from '@mm/state/interfaces/leads';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { selectFreezedCreditsSum } from '@mm/state/selectors/leadsSearchSelectors';
import { abbreviateNumber } from '@mm/utils';
import { Divider } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './LeadsSearch.module.css';
import { LeadsSearchFilterBar } from './LeadsSearchFilterBar/LeadsSearchFilterBar';
import { LeadsSearchFiltersMenu } from './LeadsSearchFiltersMenu/LeadsSearchFiltersMenu';
import { PurchaseContactsTable } from './PurchaseContactsTable/PurchaseContactsTable';

export const LeadsSearch = () => {
  const [filterParams, setFilterParams] = useState<LeadsSearchQuery>({
    query: [],
    exclude: [],
    offset: 0,
  });
  const hasFilters = !!(
    filterParams.exclude?.length || filterParams.query.length
  );
  const freezedCreditsSum = useSelector(selectFreezedCreditsSum);
  const facebookPage = useSelector(activeFacebookPageSelector);

  const creditsBalance = Math.floor(
    Number(facebookPage?.outgoingMessagesLimit) -
      Number(facebookPage?.outgoingMessageUsage?.subscriptionMessagingCount) -
      freezedCreditsSum,
  );

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        Leads Search — 250M
        <div className={styles.creditsBalance}>
          Credits balance: {abbreviateNumber(creditsBalance)}
        </div>
      </div>

      <div className={styles.content}>
        <LeadsSearchFiltersMenu
          filterParams={filterParams}
          setFilterParams={setFilterParams}
        />
        <div className={styles.contacts}>
          <LeadsSearchFilterBar
            filterParams={filterParams}
            setFilterParams={setFilterParams}
          />

          {hasFilters && <Divider style={{ margin: '12px 0px 22px' }} />}

          <PurchaseContactsTable
            filterParams={filterParams}
            setFilterParams={setFilterParams}
          />
        </div>
      </div>
    </div>
  );
};
